import { inject, Injectable } from "@angular/core";
import { AppConsts } from "@shared/AppConsts";
import { AppSessionService } from "@shared/session/app-session.service";
import { SupportNPSService } from "app/wapps/system/support/support-nps.service";
import { HealthFeatures } from "./wapps/health/feature-names";

declare global {
    interface Window {
        Produktly: any;
        ProduktlyQ: any;
    }
}

@Injectable({
    providedIn: "root",
})
export class HtmlInjectorService {
    private _appSession = inject(AppSessionService);

    wootricScriptUrl = "https://cdn.wootric.com/wootric-sdk.js";

    private browserGlobals = {
        windowRef(): any {
            return window;
        },
        documentRef(): any {
            return document;
        },
    };

    constructor(private _npsService: SupportNPSService) {}

    public init() {
        const doc = this.browserGlobals.documentRef();

        if (AppConsts.SupportChat === "hubspot") {
            let hubspotChatConfigScript = doc.createElement("script");
            hubspotChatConfigScript.type = "text/javascript";
            hubspotChatConfigScript.innerHTML = "window.hsConversationsSettings = {loadImmediately: false,};";
            hubspotChatConfigScript.id = "hubspot-chat-config";
            doc.getElementsByTagName("head")[0].appendChild(hubspotChatConfigScript);

            let hubspotChatScript = doc.createElement("script");
            hubspotChatScript.id = "hs-script-loader";
            hubspotChatScript.src = "//js.hs-scripts.com/39655218.js";
            hubspotChatScript.type = "text/javascript";
            hubspotChatScript.async = true;
            hubspotChatScript.defer = true;
            doc.getElementsByTagName("head")[0].appendChild(hubspotChatScript);
        }

        if (AppConsts.WootricEnabled) {
            let script = doc.createElement("script");
            script.id = "wootric-js";
            script.src = this.wootricScriptUrl;
            script.type = "text/javascript";
            script.async = true;
            doc.getElementsByTagName("head")[0].appendChild(script);
            this._npsService.init();
        }

        if (AppConsts.BannerEnabled) {
            window.Produktly =
                window.Produktly ||
                new Proxy(() => {}, {
                    get: function (_, n) {
                        return (...a) => {
                            window.ProduktlyQ = (window.ProduktlyQ || []).concat([[n, a]]);
                        };
                    },
                    apply: function (_, __, a) {
                        window.ProduktlyQ = (window.ProduktlyQ || []).concat([["apply", a]]);
                    },
                });

            let produktlyScript = doc.createElement("script");
            produktlyScript.id = "produktlyScript";
            produktlyScript.src = "https://public.produktly.com/js/main.js";
            produktlyScript.async = true;
            produktlyScript.dataset.clientToken =
                "1c3bf11daa77a26fe3f5d65b7112b3572c4bff49ca52e35441d54288099820c3da75e26b5fe39190c083aa61ac653a34383a3c9f0d6689bba98c2794c9281bb4";

            doc.getElementsByTagName("head")[0].appendChild(produktlyScript);

            if (!this._appSession.isHostUser() && this._appSession.userId) {
                window.Produktly.identifyUser(this._appSession.userId, {
                    plan: this._appSession.tenantInfo?.edition?.name,
                    companyId: this._appSession.tenantId,
                    createdAt: this._appSession.user?.creationTime,
                    meetDomain: abp.setting.get(HealthFeatures.MeetDomain),
                });
            }
        }
    }
}
